import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="payment-cancel-page">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-red-600" />
          </div>
          <h2 className="font-heading text-2xl font-semibold mb-2">Payment Cancelled</h2>
          <p className="text-muted-foreground mb-6">
            Your payment was cancelled. No charges were made. You can complete your subscription payment at any time after approval.
          </p>
          <div className="space-y-3">
            <Link to="/register">
              <Button className="w-full bg-primary hover:bg-primary/90">
                Try Again
              </Button>
            </Link>
            <Link to="/">
              <Button className="w-full" variant="outline">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
